import React from 'react';

class FeedPostAvatar extends React.PureComponent {
  render() {
    let post = this.props.post;
    return (
      <div className="toleft box-s">
        <div className="user">
          <a href={post._links.actor.href}>
            <img src={post._links.actor_profile_picture.href} />
          </a>
        </div>
      </div>
    );
  }
}

export default FeedPostAvatar;
